import { ILabState } from './ILabState';
import { McAction } from '../../IMcAction';
import { Lab } from '../../../contracts/lab/lab.model';
import { LabInstrument } from '../../../contracts/instrument/lab-instrument.model';
import { LabTestData } from '../../../contracts/lab-test/legacy/test-data.model';
import { StudyTestTeaConfigs } from '../../../contracts/common/study-test-tea-config.model';

export function selectCurrentLab(state: ILabState, action: McAction): ILabState {
    return Object.assign({}, state, {
        currentLab: action.payload
    } as ILabState);
}

export function clearCurrentLab(state: ILabState, action): ILabState {
    return Object.assign({}, state, {
        currentLab: null,
        currentLabInstruments: [],
    } as ILabState);
}

export function getLabSuccess(state: ILabState, action: McAction): ILabState {
    return Object.assign({}, state, {
        labs: action.payload as Lab[]
    } as ILabState);
}

export function getLabInstruments(state: ILabState, action: McAction): ILabState {
    return Object.assign({}, state, {
        currentLabInstruments: action.payload as LabInstrument[]
    } as ILabState);
}


export function getStudyTestTeaConfigs(state: ILabState, action: McAction): ILabState {
    return Object.assign({}, state, {
        studyTestTeaConfigs: action.payload as StudyTestTeaConfigs
    } as ILabState);
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/modules/lab/lab.reducer.logic.ts